<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">CEO Summary</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <userpilot-flow :id="userpilotId" :variant="'neutral'" :size="'sm'"></userpilot-flow>
          <base-button size="sm" type="neutral" v-b-toggle.filters>
            <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
            <span class="btn-inner--text">Filters</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-collapse visible id="filters">
        <b-card>
          <b-row>
            <b-col md="4">
              <base-input label="Report Type" label-for="reportType">
                <el-select v-model="reportType">
                  <el-option v-for="type in reportTypes"
                             :key="type.label"
                             :label="type.label"
                             :value="type.value">
                  </el-option>
                </el-select>
              </base-input>
            </b-col>
            <b-col md="4">
              <base-input label="Period" label-for="yearInput">
                <el-select v-model="period">
                  <el-option value="monthly" label="Monthly"></el-option>
                  <el-option value="quarterly" label="Quarterly"></el-option>
                </el-select>
              </base-input>
            </b-col>
            <b-col md="4">
              <base-input label="Year" label-for="yearInput">
                <el-select v-model="year">
                  <el-option v-for="year in years"
                             :key="year.label"
                             :label="year.label"
                             :value="year.value">
                  </el-option>
                </el-select>
              </base-input>
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>

      <monthly-summary :period="period" :year="year" v-if="reportType == 'monthly-summary'"></monthly-summary>
      <cap-royalties :userRoute="userRoute" :year="year" v-if="reportType == 'cap-royalties'"></cap-royalties>
      <projected-profits :period="period" :year="year" v-if="reportType == 'projected-profits'"></projected-profits>
      <business-plan :period="period" :year="year" v-if="reportType == 'business-plan'"></business-plan>
    </b-container>
  </div>
</template>
<script>
// Components
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui'
import MonthlySummary from './CeoSummary/MonthlySummary';
import CapRoyalties from './CeoSummary/CapRoyalties';
import ProjectedProfits from './CeoSummary/ProjectedProfits';
import BusinessPlan from './CeoSummary/BusinessPlan';
import UserpilotFlow from '@/views/Components/UserpilotFlow';

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    MonthlySummary,
    CapRoyalties,
    ProjectedProfits,
    BusinessPlan,
    UserpilotFlow
  },
  data() {
    return {
      period: 'monthly',
      year: new Date().getFullYear(),
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
      reportType: 'monthly-summary',
      reportTypes: [
        { value: 'monthly-summary', label: 'Monthly Summary' },
        { value: 'cap-royalties', label: 'Broker/Franchise Fees' },
        { value: 'projected-profits', label: 'Projected Net Profits' },
        { value: 'business-plan', label: 'Business Plan' }
      ]
    };
  },
  computed: {
    ...mapGetters({
      subBasic: 'observed/subBasic',
      subStandard: 'observed/subStandard',
      subPremium: 'observed/subPremium'
    }),
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    },
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    userpilotId(){
      return this.subscribed ? '1670428789aMnc5895' : '1672325511tDam6313';
    },
    observed() {
      const observed = this.$store.getters['observed/observed'];

      return observed.roles[0] == 'owner';
    }
  },
  mounted() {
    document.title = 'CEO Summary';
  }
}
</script>